<template>
    <Card>
        <div class="yl-flex">
            <div class="yl-flex" style="width: 280px">
                <Input v-model="name" style="width: 200px" placeholder="请输入分公司名称">
                    <i-button slot="append" icon="ios-search"></i-button>
                </Input>
                <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
            </div>
        </div>
        <div style="margin-top: 20px;">
            <Table size="small" :columns="columns" :data="data">
                <template slot-scope="{row, index}" slot="arrival_amount">
                    <Input v-model="data[index].arrival_amount" v-if="row.status == -1" />
                    <div v-else>{{data[index].arrival_amount}}</div>
                </template>
                <template slot-scope="{row, index}" slot="action">
                    <div  v-if="row.status == -1">
                        <span class="blue" :data-index="index" @click.stop="save">通过保存</span>
                        <span class="red" :data-index="index" @click.stop="refuse">有误拒绝</span>
                    </div>
                    <div v-else>--</div>
                </template>
            </Table>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage"
                      size="small" show-total show-elevator/>
            </div>
        </div>

    </Card>
</template>

<script>
    import {getShopRechargeList,saveRecharge} from '@/api/runSet'
    import {mapGetters, mapActions} from "vuex";

    export default {
        name: "JuniorRecharge",
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
        created(){
            this.getList();
        },
        data() {
            return {
                count: 0,
                page: 1,
                name: '',
                columns: [{
                    title: '渠道名称',
                    key: 'name',
                    width: '100'
                },
                    {
                        title: 'ID',
                        key: 'id',
                        width: '50'
                    },
                    {
                        title: '充值金额',
                        key: 'recharge_amount'
                    },
                    {
                        title: '付款人银行账户名',
                        key: 'account_name',
                    },
                    {
                        title: '付款人开户行',
                        key: 'bank_name',
                    },
                    {
                        title: '付款人银行卡号',
                        key: 'bank_account',
                    },
                    {
                        title: '状态',
                        key: 'status_name',
                    },
                    {
                        title: '到账金额',
                        slot: 'arrival_amount'
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: '130'
                    },
                ],
                data: []
            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            search() {
                this.page = 1;
                this.getList();
            },
            changePage(e) {
                this.page = e;
                this.getList();
            },
            async getList() {
                let that = this;
                let data = {token: that.token, page: that.page, name: that.name};
                let res = await getShopRechargeList(that, data);
                if (res.code == 1) {
                    that.data = res.data.list;
                    that.count = res.count;
                }
            },
            save(e) {
                let that = this;
                let index = e.currentTarget.dataset.index;
                that.$Modal.confirm({
                    title: '确认通过吗？',
                    onOk: async() => {
                        this.throttle(async function() {
                            let data = {token: that.token, money: that.data[index].arrival_amount, id:that.data[index].id, status: 1};
                            let res = await saveRecharge(that, data);
                            if (res.code == 1) {
                                that.$Message.success(res.msg);
                                that.getList();
                            }
                        }, 500)
                    }
                })
            },
            refuse(e) {
                let that = this;
                let index = e.currentTarget.dataset.index;
                that.$Modal.confirm({
                    title: '确认拒绝吗？',
                    onOk: async() => {
                        this.throttle(async function() {
                            let data = {token: that.token, money: that.data[index].arrival_amount, id:that.data[index].id, status: -2};
                            let res = await saveRecharge(that, data);
                            if (res.code == 1) {
                                that.$Message.success(res.msg);
                                that.getList();
                            }
                        }, 500)
                    }
                })
            },

        }
    }
</script>

<style scoped lang="less">
    .yl-flex {
        display: flex;
        justify-content: space-between;
        padding-bottom: 0;
    }

    .add_flex {
        display: flex;
        align-items: center;
        margin: 10px 0;
    }

    .add_title {
        margin: 0 10px;
        font-weight: bold;

    }

    .ivu-upload {
        display: flex;
        align-items: center;
    }
    .blue{
        color: #54A1F3;
    }
    .red{
        padding-left: 10px;
        color: red;
    }
</style>
